import {IRouteProps} from "../../../ts/manager/view/ViewInterface";
import RouteModel from "../../../ts/model-factory/basic/route/RouteModel";
import RouteChoice from "../../../ts/model-factory/basic/route/RouteChoice";
import CardDeckView from "../snippet/CardDeckView";

interface IProps
{
    routeProps: IRouteProps
    routeModel:RouteModel
    includeIDs?:string[];
    excludeIDs?:string[];
    title?:string;
}

const NavRelatedPostsView = (props: IProps) =>
{
    const routeProps = props.routeProps;
    const routeChoice = routeProps.choice;
    let routeChoiceList:RouteChoice[] = [];

    const fromChoiceList = props.routeModel.choiceList();
    for(let altChoice of fromChoiceList){
        if((altChoice.navigationRouteKey === routeChoice.navigationRouteKey) && (altChoice.id === routeChoice.id)){
            continue;
        }
        if(altChoice.postDataChoice && (altChoice.postDataChoice.postStatus !== "publish")){
            continue;
        }
        routeChoiceList.push(altChoice);
    }
    for(let i = 0; i < routeChoiceList.length; i++){
        let valid = i <= 2;
        if(props.includeIDs && !props.includeIDs.includes(routeChoice.id)){
            valid = false
        } else if(props.excludeIDs && props.excludeIDs.includes(routeChoice.id)){
            valid = false
        }
        if(!valid){
            routeChoiceList.splice(i, 1);
            i --;
        }
    }
    if(!routeChoiceList.length){
        return <></>
    }

    const isSlick = routeChoiceList.length > 1;
    return <section className="content-block set-bg-secondary set-bg-grey related-posts">
        <div className="container-fluid px-4">
            {props.title && <>
                <div className="row">
                    <div className="col-12 text-center">
                        <h2 className="block-title mb-5">{props.title}</h2>
                    </div>
                </div>
            </>}
            <CardDeckView
                routeChoiceList={routeChoiceList}
                isSlick={isSlick}
                removeData={true}
                desktopCols={3}
                useID="relatedPostsTicker"
            />

        </div>
    </section>
}
export default NavRelatedPostsView;